<template>
  <div class="cartypes">
    <!-- 步骤条 -->
    <div class="steps">
      <!-- 品牌 -->
      <!-- <div class="steps-brand" v-show="brand"> -->
      <div class="steps-one" v-show="brand">
        <ul>
          <li>
            <img src="@/assets/images/carImg/status1/group 230.png" alt="" />
            <span>选择品牌</span>
          </li>
          <div class="steps-img">
            <img src="@/assets/images/carImg/arrows/group -1.png" alt="" />
          </div>
          <li>
            <img src="@/assets/images/carImg/status1/group 231.png" alt="" />
            <span>选择车系</span>
          </li>
          <div class="steps-img">
            <img src="@/assets/images/carImg/arrows/group -1.png" alt="" />
          </div>
          <li>
            <img src="@/assets/images/carImg/status1/group 232.png" alt="" />
            <span>选择车型</span>
          </li>
        </ul>
        <div class="steps-brand">
          <!-- 字母 -->
          <div class="steps-brandName">
            常用车型：<span
              @click="checkedBrand(item)"
              v-for="(item, index) in alphabet"
              :key="index"
              :class="carchecked1 === item ? 'checked' : ''"
              >{{ item }}
            </span>
          </div>
          <!-- 图片 -->
          <div class="steps-brandImg">
            <ul>
              <li
                v-for="item in alphabetImgs"
                :key="item.carBrandId"
                @click="checkImg(item)"
              >
                <img
                  :src="
                    item.cmBrandImageUrl == null
                      ? 'https://vin.g-part.cn/images/brand/%E5%A4%A9%E9%99%85.jpg'
                      : item.cmBrandImageUrl
                  "
                  alt=""
                />
                <span>{{ item.cmBrand }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- </div> -->

      <!-- 车系 -->
      <!-- <div class="steps-carseries" v-show="carseries"> -->
      <div class="steps-one" v-show="carseries">
        <ul>
          <li>
            <img src="@/assets/images/carImg/status1/group 230.png" alt="" />
            <span>选择品牌</span>
          </li>
          <div class="steps-img">
            <img src="@/assets/images/carImg/arrows/group 92.png" alt="" />
          </div>
          <li>
            <img src="@/assets/images/carImg/status2/group 231.png" alt="" />
            <span>选择车系</span>
          </li>
          <div class="steps-img">
            <img src="@/assets/images/carImg/arrows/group -1.png" alt="" />
          </div>
          <li>
            <img src="@/assets/images/carImg/status1/group 232.png" alt="" />
            <span>选择车型</span>
          </li>
        </ul>
        <div class="steps-carseries">
          <div class="steps-carseries-top">
            已选车型
            <span>
              {{ nameList.brandName }}
              <Icon type="md-close-circle" size="14" @click="delbrandName"
            /></span>
          </div>
          <!-- <div class="divs"> -->
          <div
            class="steps-carseries-bottom"
            v-for="(item, index) in carSeries"
            :key="index"
          >
            <p>{{ item }}</p>
            <div class="divs">
              <span
                v-for="i in a"
                v-show="item == i.cmFactory"
                :key="i.cmCar"
                @click="checkCarBrand(i)"
                >{{ i.cmCar }}</span
              >
            </div>
          </div>
        </div>
      </div>

      <!-- 车型 -->
      <!-- <div class="steps-cartype" v-show="cartype"> -->
      <div class="last-box" v-show="cartype">
        <div class="steps-one">
          <ul>
            <li>
              <img src="@/assets/images/carImg/status1/group 230.png" alt="" />
              <span>选择品牌</span>
            </li>
            <div class="steps-img">
              <img src="@/assets/images/carImg/arrows/group 92.png" alt="" />
            </div>
            <li>
              <img src="@/assets/images/carImg/status2/group 231.png" alt="" />
              <span>选择车系</span>
            </li>
            <div class="steps-img">
              <img src="@/assets/images/carImg/arrows/group 92.png" alt="" />
            </div>
            <li>
              <img src="@/assets/images/carImg/status2/group 232.png" alt="" />
              <span>选择车型</span>
            </li>
          </ul>
          <div class="steps-cartype">
            <div class="steps-carseries-top">
              已选车型
              <span
                >{{ nameList.brandName }}
                <Icon type="md-close-circle" size="14" @click="delbrandName"
              /></span>
              <img src="@/assets/images/carImg/arrows-img.png" alt="" />
              <!-- <Icon type="md-arrow-round-forward" color="#DEDEDE" size="14" /> -->
              <span
                >{{ nameList.carName }}
                <Icon type="md-close-circle" size="14" @click="delcartypeName"
              /></span>
              <img src="@/assets/images/carImg/arrows-img.png" alt="" />
              <!-- <Icon type="md-arrow-round-forward" color="#DEDEDE" size="14" /> -->
              <span
                >{{ carchecked3 }}
                <Icon type="md-close-circle" size="14" @click="deleteCarType"
              /></span>
            </div>
            <div class="steps-cartype-bottom">
              <!-- <div class="steps-cartype-search">
                <Input
                  v-model="intValue"
                  placeholder="请输入想要的车型"
                  style="width: 301px"
                />
                <Button type="primary" @click="searchType" :loading="loading"
                  >搜索</Button
                >
              </div> -->
              <h2 style="margin-bottom: 10px" v-show="!showDisplacement">
                请选择车型
              </h2>
              <div
                class="steps-cartype-name"
                v-if="motorcycleType.length && !showDisplacement"
              >
                <!-- @click="cehcekType(item)" -->
                <span
                  @click="selectType(item)"
                  v-for="(item, index) in motorcycleType"
                  :key="index"
                  :class="carchecked3 === item ? 'checked3' : ''"
                  >{{ item }}
                </span>
              </div>
              <h2
                style="margin:10px 0"
                v-if="motorcycleType.length && showDisplacement"
              >
                请选择发动机排量
              </h2>
              <div
                class="steps-cartype-name"
                v-if="motorcycleType.length && showDisplacement"
              >
                <!-- @click="cehcekType(item)" -->
                <span
                  v-for="(item, index) in displacementYear"
                  :key="index"
                  @click="cehcekType(item)"
                  :class="
                    carchecked4 === item.cmDisplacement + '|' + item.cmModelYear
                      ? 'checked3'
                      : ''
                  "
                  >{{ item.cmDisplacement }} {{ item.cmModelYear }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="steps-cartype-btn">
          <Button type="primary" class="last-box-btn" @click="btnok"
            >确定</Button
          >
        </div>
      </div>

      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import {
  getSoPeiCarBrandList,
  getSoPeiFactoryModel,
  getSoPeiDisplacementYear,
  getListCarSeries,
  getCarModel
} from '@/api/partnavigation.js'
export default {
  components: {},
  data() {
    return {
      nameList: {
        carName: '', // 选中车系名字
        brandName: '', // 选中品牌名字
        // modelVO:{
        brand: '',
        series: '',
        model: '',
        model_year: '',
        cc: '',
        trans_code: ''
        // }
      },
      carNameList: '',
      carchecked3: '',
      carchecked4: '',
      loading: false,
      carList: {},
      motorcycleType: [], // 车型数据
      showDisplacement: false, //排量 年份是否显示
      displacementYear: [], //排量年份
      intValue: '', // 车型输入框
      carSeries: [], // 车系数据
      carchecked1: '', // 选中字母开头
      brand: true, // 品牌显示
      carseries: false, // 车系显示
      cartype: false, // 车型显示
      alphabetList: {}, // 厂牌数据字母
      alphabet: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z'
      ],
      alphabetImgs: [], // 选中字母图片数据
      a: '',
      cmFactory: ''
    }
  },
  created() {
    // this.getlistAllLabel()
  },
  methods: {
    // 获取品牌
    async getlistAllLabel() {
      this.showDisplacement = false

      this.nameList = {}
      this.carchecked3 = ''
      this.carchecked1 = 'A'
      const res = await getSoPeiCarBrandList()
      console.log(res)
      let list = (res.data && res.data.list) || []
      this.alphabet.forEach(item => {
        this.alphabetList[item] = []
      })
      this.alphabet.forEach(item => {
        list.forEach(val => {
          if (val.cmBrandLetter == item) {
            this.alphabetList[item].push(val)
          }
        })
      })
      // this.alphabet = res.data.firstChar
      // this.alphabetList = res.data.relation
      this.alphabetImgs = this.alphabetList[this.carchecked1]
      this.brand = true
      this.carseries = false
      this.cartype = false
    },
    // 点击切换字母状态
    checkedBrand(item) {
      this.carchecked1 = item
      this.alphabetImgs = this.alphabetList[this.carchecked1]
    },
    // 选品牌
    async checkImg(item) {
      this.intValue = ''
      console.log(item)
      const res = await getSoPeiFactoryModel({ cmBrand: item.cmBrand })
      console.log(res)
      if (res.status) {
        this.carSeries = res.data.cmFactoryList || []

        this.nameList.brandName = item.cmBrand
        this.a = (res.data && res.data.list) || []
        this.brand = false
        this.carseries = true
      }
    },
    // 删除品牌
    delbrandName() {
      this.delcartypeName()
      this.nameList.brandName = ''
      this.brand = true
      this.carseries = false
      this.showDisplacement = false
      this.showDisplacement = false
      this.carchecked2 = ''
    },
    // 删除车系列
    delcartypeName() {
      this.nameList.carName = ''
      this.nameList.id = ''
      this.brand = false
      this.carseries = true
      this.cartype = false
      this.intValue = ''
      this.carchecked3 = ''
      this.carchecked4 = ''
      this.showDisplacement = false
    },
    // 删除车型
    deleteCarType() {
      if (this.showDisplacement) {
        this.brand = false
        this.carseries = false
        this.cartype = true
        this.showDisplacement = false
      } else {
        this.brand = false
        this.carseries = true
        this.cartype = false
        this.carchecked3 = ''
        this.carchecked4 = ''
      }
    },
    // 选择车系
    async checkCarBrand(i) {
      console.log(i)
      this.displacementYear = []
      this.nameList.carName = i.cmCar
      this.motorcycleType = i.cmModels
      this.cmFactory = i.cmFactory
      this.carList = i
      this.brand = false
      this.carseries = false
      this.cartype = true
      // const res = await getCarModel({ id: i.id })
      // console.log(res, '111111')
      // if (res.status) {
      //   this.nameList.carName = i.name

      //   this.motorcycleType = res.data.list

      // }
    },
    // 根据车型获取排量、年份
    async selectType(value) {
      this.carchecked3 = value
      this.showDisplacement = true
      console.log(value, 'cmModel')
      const res = await getSoPeiDisplacementYear({
        cmBrand: this.nameList.brandName,
        cmFactory: this.cmFactory,
        cmModel: value
      })
      if (res.status) {
        this.displacementYear = (res.data && res.data.list) || []
      }
      console.log(res, 'ss')
    },
    // 搜索车型
    async searchType() {
      this.loading = true
      const res = await getCarModel({
        id: this.carList.id,
        name: this.intValue
      })
      console.log(res)
      if (res.status) {
        this.motorcycleType = res.data.list
        this.brand = false
        this.carseries = false
        this.cartype = true
      }
      this.loading = false
    },
    // 选中车型状态
    cehcekType(val) {
      console.log(val)
      console.log(this.nameList)
      this.carchecked4 = val.cmDisplacement + '|' + val.cmModelYear
      this.carNameList = {
        cmBrand: this.nameList.brandName,
        cmFactory: this.cmFactory,
        cmModel: this.carchecked3,
        cmDisplacement: val.cmDisplacement,
        cmModelYear: val.cmModelYear,
        series: this.nameList.carName
      }

      console.log(this.carNameList, 'carchecked4')
      this.$emit('closeMOdal', this.carNameList)
      this.carchecked4 = ''
      this.carchecked3 = ''
      this.carchecked2 = ''
      this.showDisplacement = false
    },
    // 确定车型
    btnok() {
      console.log(this.carchecked3, '111111111111')
      if (this.carchecked4 == '') {
        this.$Message.warning('请选择年份、排量')
      } else {
        // console.log(this.nameList)
        // console.log(this.nameList.carType)
        // this.carNameList = JSON.parse(JSON.stringify(this.nameList))
        this.$emit('closeMOdal', this.carNameList)
        console.log(this.carchecked3)
      }
    }
  },
  computed: {},
  watch: {}
}
</script>
<style lang="less" scoped>
@import './index.less';
</style>
